<template>
  <div class="container-cidades">
    <br>
    <div class="row">
       
       <img src="/img/flag_pendente.jpg" class="img-fluid " v-if="status == 'Pendente'"/>
       <img src="/img/flag_atendimento.jpg" class="img-fluid " v-if="status == 'Em Atendimento'"/>
       <img src="/img/flag_mediachance.jpg" class="img-fluid " v-if="status == 'Média Chance'"/>
       <img src="/img/flag_poucachance.jpg" class="img-fluid " v-if="status == 'Pouca chance'"/>
       <img src="/img/flag_hot.jpg" class="img-fluid " v-if="status == 'Cliente hot'"/>
       <img src="/img/flag_vendido.jpg" class="img-fluid " v-if="status == 'Arquivado Vendido'"/>
       <img src="/img/flag_naovendido.jpg" class="img-fluid " v-if="status == 'Arquivado Não Vendido'"/>
       <div class="col-sm-12"><router-link to="/buscaLeads" class="btn btn-danger float-right">VOLTAR</router-link><h2 class="text-center">Prospects de Venda</h2><hr>
        <p class="text-center" style="" v-if="lead != null">Data da entrada: {{ dataCadastro }}<br> Última atualização: {{ dataAtualizacao }}</p>
       
       <v-avatar-uploader id="avatar"
    :url="url"
    :request="request"
  />
  <div class="text-white text-bold text-center" style="background:green;" v-if="agendado == 2"><small class="px-3"><i>DESTACADO: {{ dataAtualizacao }}</i></small></div>
       </div>


<form class="row mt-3" method="POST" ref="formulario" @submit.prevent.stop="add">

   

  <div class="form-group col-sm-4">
          <label>Nome:</label>
          <input type="text" name="nome" class="form-control"  v-model="nome"/>
        </div>

        <div class="form-group col-sm-4">
          <label>Referência:</label>
             <img src="/img/check.png" style="width:50px;height:auto;display:inline-block;cursor:pointer;" class="img-fluid mt-n3" :class="{'colorless':checado == false}" />
          <input type="text" name="referencia" class="form-control"  v-model="referencia"/>
        </div>

  

          <div class="form-group col-sm-4">
          <label>Valor:</label>
          <input type="text" name="valor" class="form-control" v-money="money" v-model.lazy="valor" />
        </div>

 <div class="form-group col-sm-4">
          <label>Metragem:</label>
          <input type="text" name="metragem" class="form-control" v-model="metragem" />
        </div>
        
  <div class="form-group col-sm-4">
          <label>Edificio:</label>
          <AutocompleteCustom ref="autocomplete" :resultados.sync="matches" :nome.sync="edificioSelecionado" @pronto="addEdificio" url="autocompleteEdificios" classe="autocompleteEdificios"></AutocompleteCustom>
          
        </div>
       
        <div class="form-group col-sm-4 ">
          <label>Região:</label>
    <AutocompleteRegiao ref="autocompleteRegiao" :resultados.sync="matchesRegiao" :nome.sync="bairroSelecionado" @pronto="addBairro" url="autocompleteBairros" classe="autocompleteEdificios"></AutocompleteRegiao>
</div>

          <div class="form-group col-sm-4">
          <label>Telefone:</label>
          <input type="number" name="telefone" class="form-control" v-model="telefone" />
        </div>

            <div class="form-group col-sm-4">
          <label>E-mail:</label>
          <input type="text" name="email" class="form-control" v-model="email" />
        </div>

         <div class="form-group col-sm-3">
          <label>Adicionar Imóvel:</label>
          <input type="text" name="imovel" class="form-control" v-model="imovel" />
        </div>

        <div class="form-group col-sm-1">
          <button type="button" role="button" @click="addImovel" class="btn btn-success mt-3">+</button>
        </div>

         <ul class="col-sm-4">
          <li class="badge badge-warning mr-2 p-2"  v-for="(item,index) in oferecidos" :key="item">{{item}} <small></small> <span @click="oferecidos.splice(index, 1)" class="badge badge-danger" style="cursor:pointer;">X</span> <a class="d-block  text-white mt-1" :href="'https://www2.royaljardim.com.br/site/imovel/' +item" target="_blank">Visitar</a></li>
        </ul>

        <div class="form-group col-sm-12">
          <label>Observações:</label>
          <textarea  name="observacao" class="form-control" v-model="observacao"></textarea>
        </div>

         <div class="form-group col-sm-11" v-if="acao == 2">
          <label>Histórico de contato:</label>
          <textarea  name="historico" class="form-control" v-model="historico"></textarea>
         
        </div>

         <div class="form-group col-sm-1" v-if="acao == 2">
          <button type="button" role="button" @click="addHistorico" class="btn btn-success mt-5">+</button>
        </div>

         <div class="form-group col-sm-5">
          <label>Status:</label>
          <select class="form-control" name="status" v-model="status">
           <option value="Pendente">Aguardando Atendimento</option>
            <option value="Em Atendimento">Reunindo Informações</option>
            <option value="Pouca chance">Procurando imóvel sem dinheiro</option>
             <option value="Média Chance">Procurando imóvel com permuta</option>
              <option value="Cliente hot">Procurando imóvel com dinheiro</option>
               <option value="Arquivado Vendido">Arquivado Vendido</option>
               <option value="Arquivado Não Vendido">Arquivado Não Vendido</option>
                <option value="Dificil Contato">Dificil Contato</option>
                  <option value="Duplicidade">Duplicidade</option>
          </select>
        </div>

         <div class="form-group col-sm-4">
          <label>Corretor:</label>
            <select class="form-control" name="corretor" v-model="corretor">
          
            <option v-for="user in usuarios" :key="user.LOG_ID" :value="user.LOG_ID">{{user.LOG_NOME}}</option>
            </select>
        </div>

          <button  type="submit" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">+SALVAR</button>

          

          

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
</form>
<hr><br><br>
 

    </div><!-- row -->

    <!-- sugestoes -->
    <div class="row">
  <div class="col">
    <h3>Sugestões de imóveis</h3><hr>
  </div>
</div>
<sugestoes v-if="referencia != ''" :lead.sync="referencia"/>

<br><br>
<!-- sugestoes -->
    <div class="row">

      <div v-if="showStatus" class="alert alert-info col-sm-12" role="alert">
       Informações atualizadas com sucesso!
       </div>
    
<section v-if="acao == 2" class="col">
<h4 class="">Destacar Contato</h4><hr>
             <!-- <input type="datetime-local" class="form-control"  name="agenda" v-model="agenda"> -->
                <button @click="agendar"  type="button" role="button" class="btn btn-success mt-2" style="">DESTACAR</button>
                 <button v-if="agendado == 2" @click="desagendar"  type="button" role="button" class="btn btn-danger mt-2 ml-2" style="">RETIRAR DESTAQUE</button>
                <br><br>
<h4>Ações complementares</h4><hr>
   <!-- <button @click="show"  type="button" role="button" class="btn btn-warning  mr-2 " style="">DESTACAR</button> -->

   <a target="_blank" :href="'https://api.whatsapp.com/send?phone=55' + telefone"   class="btn btn-success  mr-2 " >WHATSAPP</a>
    <a :href="'tel:+55' + telefone"   class="btn btn-info  mr-2 " >LIGAR</a>
    <button @click="showEmail"  type="button" role="button" class="btn btn-danger  mr-2 " style="">E-MAIL</button>
    <button @click="aluguel"  type="button" role="button" class="btn btn-dark  mr-2 " style="">ALTERNAR PARA ALUGUEL</button>
<br><br>
<h4>Histórico</h4><hr>
          <div class="alert alert-info mb-2" v-for="conversa in historicos" :key="conversa.HI_ID"><strong>{{conversa.HI_DATA}}</strong> - {{conversa.HI_TEXTO}}</div>
  </section>

    </div><!-- row cards -->

<!--modal  -->

    <modal name="my-first-modal">
        <section class="p-3">
            <h3 class="text-center">Agendar Contato</h3><hr>
             <input type="datetime-local" class="form-control"  name="agenda" v-model="agenda">
                <button @click="agendar"  type="button" role="button" class="btn btn-success mt-2 " style="">DESTACAR</button>
        </section>
    </modal>
<!-- -->



<!--modal  -->

    <modal name="my-first-modal2">
        <section class="p-3">
            <h3 class="text-center">Enviar E-mail</h3><hr>
             <textarea class="form-control w-100" rows="5" name="agenda" v-model="msg"></textarea>
                <button @click="enviarEmail"  type="button" role="button" class="btn btn-success mt-2" style="">ENVIAR</button>
        </section>
    </modal>
<!-- -->

  </div>
</template>

<style>
.colorless{filter: grayscale(1);}
#avatar img{max-width:150px;height:auto;}
</style>

<script>
import axios from 'axios'
import AutocompleteCustom from '@/components/AutocompleteCustom'
import AutocompleteRegiao from '@/components/AutocompleteRegiao'
import VAvatarUploader from 'vuetify-avatar-uploader'
import Sugestoes from '@/components/Sugestoes'


export default {
  name: 'Leads',
  components: {AutocompleteCustom, AutocompleteRegiao,VAvatarUploader,Sugestoes},

  data(){
      return {
        checado:false,
        agendado: "",
        msg:"",
        avatar:'/img/avatar-bg.png',
        metragem:0,
        agenda: "",
        oferecidos:[],
        imovel:"",
        historicos:[],
        historico:"",
          bairroSelecionado:'',
        selectedBairro:null,
        selectedEdificio:1119,
        edificioSelecionado:'',
             matches:[],
          acao:1,
          dataCadastro:'',
          dataAtualizacao:'',
          lead:0,
          usuarios:[],
          valor:'',
         nome:'',
          referencia:'',
          telefone:'',
         status:'Pendente',
          email:'',
          corretor:'',
          observacao:'',
          showStatus:false,
          loading: false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false
          }
      }
  },
 

methods:{
  aluguel(){
     this.loading = true;
          let fm = new FormData();
          fm.append('id',this.lead);

          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/aluguel',fm)
          .then(response => {
            console.log(response);
              this.get();
              this.showStatus = true;
              
            })
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
  },
    desagendar(){
     this.loading = true;
          let fm = new FormData();
          fm.append('id',this.lead);

          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/desagendar',fm)
          .then(response => {
            console.log(response);
              this.get();
              this.showStatus = true;
              
            })
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
  },
  agendar(){
     this.loading = true;
          let fm = new FormData();
          //fm.append('agenda',this.agenda.replace('T'," "));
           fm.append('agenda',"");
          fm.append('id',this.lead);

          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/agendar',fm)
          .then(response => {
            console.log(response);
              this.get();
              this.showStatus = true;
               this.$modal.hide('my-first-modal');
            })
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
  },
  show(){
            this.$modal.show('my-first-modal');
        },
         showEmail(){
            this.$modal.show('my-first-modal2');
        },
  addImovel(){
    this.oferecidos.push(this.imovel);
    this.imovel = "";
  },
  addHistorico(){
          this.loading = true;
          let fm = new FormData();
          fm.append('historico',this.historico);
          fm.append('id',this.lead);

          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/salvarHistorico',fm)
          .then(response => {
            console.log(response);
           this.getHistorico();
            })
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
  },
   enviarEmail(){
          this.loading = true;
          let fm = new FormData();
          fm.append('msg',this.msg);
          fm.append('email',this.email);

          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/enviarEmail',fm)
          .then(response => {
            console.log(response);
           this.$modal.hide('my-first-modal2');
            this.showStatus = true;
            })
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
  },
  addBairro(valor){
      this.selectedBairro = valor.BAI_ID;
      
    },
   addEdificio(valor){
      this.selectedEdificio = valor.ED_ID;
     
    },
    getEdificio(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getEdificio',{id:this.selectedEdificio})
          .then(response => {this.edificioSelecionado = response.data.ED_NOME;
           this.$refs.autocomplete.preencher(response.data.ED_NOME);})
          .catch(response => console.log(response))
          
    },
     getRegiao(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getRegiao',{id:this.selectedBairro})
          .then(response => {this.bairroSelecionado = response.data.BAI_NOME;
           this.$refs.autocompleteRegiao.preencher(response.data.BAI_NOME);})
          .catch(response => console.log(response))
          
    },
   getUsuarios(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getUsuarios',{})
          .then(response => this.usuarios = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },
    add(){
          this.loading = true;
          let fm = new FormData(this.$refs["formulario"]);
          fm.append('id',this.lead);
          fm.append('acao',this.acao);
          fm.append('valor',this.filtrar(this.valor));
          fm.append('nome',this.nome);
          fm.append('referencia',this.referencia);
          fm.append('telefone',this.telefone);
          fm.append('status',this.status);
          fm.append('email',this.email);
          fm.append('edificio',this.selectedEdificio);
          fm.append('bairro',this.selectedBairro);
          fm.append('corretor',this.corretor);
          fm.append('observacao',this.observacao);
          fm.append('secundario',this.oferecidos);

          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/updateLead',fm)
          .then(response => {
             if(this.acao == 1 ){
                    this.lead = response.data;
                }
            this.get();this.showStatus = true;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
      },

   
    get(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/getLead',{lead:this.lead})
          .then(response => this.updateInfo(response.data))
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },
    getHistorico(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/leads/getHistorico/'+this.lead)
          .then(response => {this.historicos = response.data; console.log(response.data);this.historico = "";})
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    filtrar(dinheiro){
      return dinheiro.replace('R$', "").replace('.', "").replace('.', "").replace(',', ".");
    },

    
    updateInfo(data){
      this.acao = 2;
      this.nome = data.LD_NOME;
      this.valor = data.LD_VALOR;
      this.referencia = data.LD_REFERENCIA;
      this.status = data.LD_STATUS;
      this.telefone = data.LD_TELEFONE;
      this.email = data.LD_EMAIL;
      this.observacao = data.LD_OBS;
      this.corretor = data.LD_CORRETOR;
    this.selectedEdificio = data.LD_EDIFICIO;
    this.selectedBairro = data.LD_BAIRRO;
      this.dataCadastro = data.LD_DATA;
       this.dataAtualizacao = data.LD_ATUALIZACAO;
      this.metragem = data.LD_METRAGEM;
      this.oferecidos = (data.LD_SECUNDARIO != null) ? data.LD_SECUNDARIO.split(',') : [];
      this.avatar = (data.LD_FOTO != null) ? "https://www2.royaljardim.com.br/sistema/fotos/"+data.LD_FOTO:'/img/avatar-bg.png';
      this.agendado = data.LD_AGENDADO;
      this.checado = data.CHECADO;
       this.getEdificio();
       this.getRegiao();
       this.getHistorico();
    },

  request(form, config) {
          console.log(config);
          this.loading = true;
          form.append('id',this.lead);
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/avatar',form)
          .then(response => {console.log(response.data); this.avatar = response.data.url;})
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)

    //console.log(this.$http.post('https://www2.royaljardim.com.br/sistema/welcome/avatar', form, config));
      //return this.$http.post('https://www2.royaljardim.com.br/sistema/welcome/avatar', form, config)
    },
     getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
     getPermissao(){
       return sessionStorage.getItem('imobiliaria');
     }

},
computed:{
  // Determine the URL to show, typically from an object representing a user
    url () {
      return this.avatar
    }
},
  
  mounted () {

  this.getUsuarios();
   if(this.$route.params.id != null){
     
      this.lead = this.$route.params.id;
      this.get();
    }
  }



}
</script>